function Contacto() {
  return (
    <section style={{ maxWidth: '1200px', margin: '0 auto', padding: '4rem 1.5rem' }}>
      <h1>Contacto</h1>
      <p>Sección en construcción. Va a integrar formulario y datos de contacto.</p>
    </section>
  );
}

export default Contacto;
